import { render } from "./addressValidation.vue?vue&type=template&id=7fa9af46&scoped=true"
import script from "./addressValidation.vue?vue&type=script&lang=js"
export * from "./addressValidation.vue?vue&type=script&lang=js"

import "./addressValidation.vue?vue&type=style&index=0&id=7fa9af46&lang=scss&scoped=true"

import exportComponent from "../../../MemberPortal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa9af46"]])

export default __exports__